import { Droppable } from "react-beautiful-dnd";
import ItemDraggable from "./ItemDraggable";

const GroupDraggable = ({ groupId, items, deleteItem }) => {
  return (
    <Droppable droppableId={`${groupId}`}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          style={getListStyle(snapshot.isDraggingOver)}
          {...provided.droppableProps}
        >
          {items?.map((item, itemId) => (
            <ItemDraggable
              key={item.id}
              item={item}
              itemId={itemId}
              deleteItem={() => deleteItem(groupId, itemId)}
            />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

const getListStyle = (isDraggingOver) => ({
  padding: "16px",
  minHeight: 200,
});

export default GroupDraggable;
